import { useContext }        from 'react';
import { PostPublishingNFT } from '@geenee/builder/src/components/modals/PostPublishingNFT/index';
import ModalUpdaterContext   from '@geenee/builder/src/lib/ModalUpdaterContext';

export const useNFTmodal = () => {
    const setModalOptions = useContext(ModalUpdaterContext);
    const showModal = (projectUrl: string) => setModalOptions({ component: PostPublishingNFT, props: { projectUrl } });
    return [ showModal ];
};
